import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">平台优势</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/60 hover:border-accent-300 transition-colors"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-accent-100 flex items-center justify-center mb-4 md:mb-5">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}